document.addEventListener('click', function (event) {
  var target = event.target.closest('[data-gtm-event]');
  if (!target) return;

  var eventName = target.dataset.gtmEvent;
  if (window.Shopify && window.Shopify.analytics && typeof window.Shopify.analytics.publish === 'function') {
    window.Shopify.analytics.publish(eventName, {
      label: target.dataset.gtmLabel || target.textContent.trim()
    });
  }
});
